import { EAssetSubtype, getRefId, type FullInvestment } from 'findef'
import IRClient from '@/modules/ir/apiClient'
import { getPotentialParents } from '@/utils/investment'
import { investmentToOption } from '@/form/options/investment'
import { pushCreateAssetParentModal } from '@/modules/asset/modals/create-asset-parent'
import { pushToast } from 'components/toast/hooks'
import { defineField, type FormFieldDefinition, type FormFieldOption } from '@/form/useForm'
import { FormScope } from '@/form/useForm/scope'

export const parentIdField = (): FormFieldDefinition<FullInvestment, any, any> =>
  defineField({
    type: 'dbObject',
    component: 'select-dropdown',
    placeholder: 'Select company from portfolio',
    options: {
      search: {
        placeholder: 'Search companies...',
        emptyStateText: 'No unlisted companies in your portfolio',
        api: {
          fetchAll: async () => {
            const investments = await IRClient.getInvestments();
            const form = FormScope.getCurrent<FullInvestment>();
            const inv = form?.state?.value;
            const thisInv = inv && inv._id ? investments.find(it => getRefId(it) === getRefId(inv)) : undefined;
            const potentialParents = getPotentialParents(thisInv, investments)
            return potentialParents.map(investmentToOption as unknown as any)
          }
        }
      },
      maxVisibleItems: 4,
      add: {
        label: 'Add New Company',
        createItem: async (_value: string) => {
          const getNewItem = async (): Promise<FormFieldOption | undefined> => {
            const time = new Date()

            const formData = await pushCreateAssetParentModal()

            const companyProfile = formData?.asset?.companyProfile

            if (!formData || !companyProfile || !companyProfile?.companyName || !formData.asset) return undefined

            const asset = await IRClient.createAsset({
              name: companyProfile.companyName,
              organizationNumber: formData.asset.organizationNumber || companyProfile.isin || '',
              type: formData.asset.type,
              subtypes: [EAssetSubtype.STOCK],
              contactEmail: '',
              ledger: {
                sharesIssued: 0,
                sharePrice: { value: 0, type: 'SEK' }
              },
              listed: false
            })

            pushToast({
              title: 'Asset created',
              subtitle: `${asset.name} was created`,
              variant: 'success',
              duration: 10
            })

            const investment = await IRClient.investInAsset(asset._id, {
              currentValue: { value: 0, type: 'SEK', time },
              invested: { value: 0, type: 'SEK', time },
              quantity: 0,
              time
            })

            return investmentToOption({
              ...investment,
              asset: asset
            })
          }

          try {
            const item = await getNewItem()
            return item
          } catch (e) {
            console.error(e)
            pushToast({
              title: 'Error',
              subtitle: `There was an error, please try again later`,
              variant: 'error',
              duration: 10
            })
          }
        }
      }
    }
  })
